import * as React from 'react';
import cx from 'classnames';

import { Switch, Route, useRouteMatch } from 'react-router-dom';

import { lazyLoadComponent } from '@frontend/app/utils/lazyLoadComponent';
import styles from './ReportingView.scss';

const { lazy } = React;
const ReportingListView = lazy(() => import('./ReportingListView'));
const ReportingDetailView = lazy(() => import('./ReportingDetailView'));

interface IProps {
  className?: string;
}

/**
 * @type {React.FunctionComponent}
 */
const ClientsView: React.FunctionComponent<React.PropsWithChildren<IProps>> = React.memo((props) => {
  const match = useRouteMatch();

  return (
    <div className={cx(styles.ReportingView, props.className)}>
      <Switch>
        <Route path={`${match.path}`} exact render={lazyLoadComponent(ReportingListView)} />
        <Route path={`${match.path}/:reportId`} render={lazyLoadComponent(ReportingDetailView)} />
      </Switch>
    </div>
  );
});

export default ClientsView;
